<script lang="ts" setup>
import type { IProps } from './wellbeing-sale--forEmployers--card.types'

defineProps<IProps>()
</script>

<template>
  <article class="card">
    <img
      class="card__image"
      :src="image"
      :alt="title"
      loading="lazy"
    >
    <div class="card__content">
      <h5 class="card__title">
        {{ title }}
      </h5>

      <p class="card__label">
        {{ label }}
      </p>

      <p class="card__description">
        {{ description }}
      </p>
    </div>
  </article>
</template>

<style lang="scss" scoped>
.card {
  max-width: 23.2rem;
  font-weight: 500;
  background-color: $white;
  border-radius: 1.2rem;

  &__image {
    width: 100%;
    height: 13.4rem;
    object-fit: cover;
    object-position: center;
    border-radius: 1.2rem;
  }

  &__title {
    @include body-2-medium;
    margin-bottom: 0.8rem;
    color: $text-400;
  }

  &__label {
    @include h10;
    margin-bottom: 0.8rem;
    color: $text-400;
  }

  &__description {
    @include body-2;
    color: $text-400;
  }

}

@include atM {
  .card {
    max-width: 34.5rem;

    &__image {
      width: 100%;
      height: 20rem;
      margin-bottom: 2.4rem;
      object-fit: cover;
      object-position: center;
      border-radius: 1.2rem;
    }

    &__title {
      @include h9;
      margin-bottom: 0.8rem;
    }
  }
}
</style>
